import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../../algorithms/styleDirection";
import { objToFormData } from "../../../algorithms";
import { addPost } from "../../../API/store/actions/discussion/discussion";
import Icon from "../../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../../userPreferences/staticWords";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../../tasks/formikValidation";
import {
  getDir,
  getCurrentLangFromRedux,
} from "../../../algorithms/styleChanges";
import Button from "../../sharedComponents/buttons/button";
import TextInput from "../../sharedComponents/inputs/textInput";
import TextArea from "../../sharedComponents/textarea/textArea";
import FileInput from "../../sharedComponents/inputs/fileInput";
import { useState } from "react";
import Switch from "../../sharedComponents/switch/switch";
import { addProfilePost } from "../../../API/store/actions/auth";

const PostForm = (props) => {
  const {
    onHide,
    communityId,
    userLogged,
    userToken,
    setProcAdded,
    procAdded,
    guestId,
  } = props;
  const [disable, setDisable] = useState(false);

  const submit = async (values) => {
    values.SenderId = parseInt(userLogged?.memberId);
    values.ReceiverId = guestId
      ? parseInt(guestId)
      : parseInt(userLogged?.memberId);
    let data = objToFormData(values);
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await addProfilePost(data, userToken);
    if (res.status <= 206) {
      setProcAdded(!procAdded);
      onHide();
      setDisable(false);
    } else {
      setDisable(false);
    }
  };
  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "profilePosts",
      submit
    )
  );
  const { values, handleChange, setFieldValue, touched, errors, handleSubmit } =
    formik;
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 30,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1"
            >
              <img
                src="/assets/images/Group 8274.png"
                width={30}
                height={30}
                alt=""
              />
            </div>

            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "#1a73e8",
                }}
              >
                إضافة منشور
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
              setDisable(false);
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-column align-items-center">
            <TextInput
              name={"Title"}
              onChange={handleChange}
              type={"text"}
              containerStyle={"col-11 my-2"}
              hiddenPlaceholder={Lang.title + "*"}
              errorMessage={formikValidation(touched, errors, "Title")}
            />
            <div className="col-11 position-relative">
              <TextArea
                rows={6}
                name={"Description"}
                onChange={handleChange}
                containerStyle={"col-12 my-2"}
                placeholder={Lang.Description + "*"}
              />
              <div style={{ position: "absolute", bottom: 15, right: 10 }}>
                <FileInput
                  name={"Attachment"}
                  onChange={(e) => {
                    setFieldValue("Attachment", e.target.files[0]);
                  }}
                  iconName={"paperclip"}
                  iconPrefix={"fas"}
                  size={15}
                  iconColor={values.Attachment ? "#1a73e8" : "#C7C7C9"}
                  backgroundSize={15}
                  backgroundColor={"white"}
                  fileName={values.Attachment.name ?? " "}
                  containerStyle={""}
                  accept={".gif, .jpg, .png, .doc, .pdf, .xlsx"}
                />
              </div>
            </div>
            <div
              style={{ fontSize: 14, color: "red" }}
              className="d-flex col-11"
            >
              {formikValidation(touched, errors, "Description")}
            </div>

            <div className="col-11 mt-4 d-flex align-items-center justify-content-center">
              <div className="mx-2">IsPrivate</div>
              <Switch
                checked={values.IsPrivate}
                name={"IsPrivate"}
                onClick={() => {
                  setFieldValue("IsPrivate", !!!values.IsPrivate);
                }}
              />
            </div>
            <Button
              disable={disable}
              content={disable ? "جاري النشر" : "نشر"}
              type={"submit"}
              containerStyle={"my-3 col-2"}
              buttonStyleType="solid"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
export default PostForm;
